(function($){
  /**
   *  menu control and setting
   */
	OH.settings.menuControl = (function(){

		var control = new Object();
    /**
     * sp ハンバーガーメニュー ファンクション
     * アコーディオンはしない
     * OH.init.jsでdom指定
     * 
     */
    //  $('.l-header__nav__sp').each(function(){
 	// 		OH.settings.menuControl.spMenu($(this), "c-spnav", "#l-utility", "l-header__nav__sp",'.l-header__logo', 'l-header__nav__list__language_select')
 	// 	});
		control.spMenu = function($parent, classPrefix, headerQuery, menuClass, logoElement) {
	    var cssName = "control_modal";
	    var $opener = $('[data-menu-toggle="menu_sp"]').eq(0);
      var openerWidth = $opener.width();
      var $searchButton　= $('[data-search-sp]').eq(0);
	    var $menu = $("." + menuClass).eq(0);
	    var isMenuOpen = false;
	    var isToggleTarget = function($elm) {
	      return ($elm.attr("id") == "l-body" || $elm.attr("id") == "l-footer" || $elm.attr("id") == "l-areaNav" || $elm.attr("id") == "l-mainVisual");
	    };

	    var transformPropName = OH.transitionalStyleProperty("transform", "_");
	    var transformOriginPropName = OH.transitionalStyleProperty("transform-origin", "_");

	    if (sheet = OH.dynamicCSS.register(cssName, true)) {
	      sheet.addRule("." + menuClass + "__pointer > span{ " + transformPropName + ":rotate(0deg);" + transformOriginPropName + ":50% 50%;transition:" + transformPropName + " 0.25s linear; }");
	      sheet.addRule("." + menuClass + "__item.is-open > ." + menuClass + "__pointer > span{ " + transformPropName + ":rotate(180deg); }");
	    }

	    /**
	     * sp menu を生成
	     */
	    var $base = $('<div>').addClass(classPrefix).css("display", "none");
      var $menuLogo = $(logoElement).html();
      var $head = $('<div>').addClass(classPrefix + "__head");
	    // var $main = $('<div>').addClass(classPrefix + "__body").css("overflow", "scroll").append($menu.css("display", "block"));
      var $main = $('<div>').addClass(classPrefix + "__body").css("overflow", "scroll").append($menu);
      // var $menuWrap = $('<div>').addClass(classPrefix + "__wrap").append($head).append($main);
	    // $(document.body).append($base.append($menuWrap));
      // var $ball = $('<i>').addClass(classPrefix + "__ball");
	    $(document.body).append($base.append($head).append($main));
      $head.append($menuLogo);

	    var $parentItems = $menu.find('.' + menuClass + '__item');

	    /**
	     * sp menu 閉じたら、子のアコーディオンもすべて閉じる
	     */
	    var closeAll = function() {
	      $parentItems.each(function() {
	        $(this).removeClass("is-open");
	        $(this).find('.' + menuClass + '__childlist').each(function() {
	          $(this).height(0);
	        });
	      });
	    };

	    /**
	     * sp menu の　アコーディオン制御
	     */
	    $parentItems.each(function() {
	      var $parentItem = $(this);
	      var $childList = $parentItem.find('.' + menuClass + '__childlist');
	      if (!$childList.length) {
	        return true;
	      }
	      var $lastChild = $parentItem.find('.' + menuClass + '__childitem:last-child').eq(0);
	      var $pointer = $('<span class="' + menuClass + '__pointer"><span><svg class="c-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#angle-down"></use></svg></span></span>');
	      $pointer.on("click", function(event) {
	        event.stopPropagation();
	        event.preventDefault();
	        var isOpen = $parentItem.hasClass("is-open");
	        closeAll();
	        if (isOpen) {
	          return;
	        }
	        $parentItem.addClass("is-open");
          // $searchBtn.addClass('is-menu_open');
	        $childList.each(function() {
	          var $measureElement = $(this).last().clone(false).height(0);
	          $(this).append($measureElement);
	          var measureElement = $measureElement.get(0);
	          var parentHeight = measureElement.offsetTop - measureElement.parentNode.offsetTop;
	          $measureElement.remove();
	          $(this).height(parentHeight);
	        });
	      });

	      $parentItem.append($pointer);
	      $parentItem.find('.' + menuClass + '__item__label').each(function() {
	        $(this).addClass("has-child");
	      });
	    });

	    var $scrollSpacer = $('<li>').addClass(menuClass + '__item is-scroller');
	    $parentItems.parent().append($scrollSpacer);

	    $menu.find('[data-primary-site]').each(function() {
	      var $label = $(this);
	      var $linkBlock = $('<div class="' + menuClass + '__altlink"><div><span>|</span><a href="' + $label.data("primarySite") + '">公式</a><svg class="c-icon is-small"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#external-link"></use></svg></div></div>');
	      $label.addClass("has-link").append($linkBlock);
	    });


	    var scrollPosition = 0;
	    var scrollPreventer = function(event) {
	      event.preventDefault();
	    };

	    var preventer = function(event) {
	      event.stopPropagation();
	    }
      
      /**
       * menu head
       * タッチで後ろにある検索などのイベントにクリックを伝えないように要素の表示もコントロール
       */
	    var toggleModalMenu = function(flag) {
	      var $header = $(headerQuery);
	      var headerHeight = $header.outerHeight();

	      if (flag != undefined) {
	        isMenuOpen = !!flag;
	      } else {
	        isMenuOpen = !isMenuOpen;
	      }
        
        /**
         * デバイスの横向きでのメニュースクロール挙動制御
         */
        var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
        var tiltLandscape = function(){
          if(deviceSP && window.innerWidth > window.innerHeight){
            $parent.css('min-height', 'calc(100% + 200px)');// bodyとbottomの高さを加算
          } else {
            $parent.css('min-height','');
          }
        }

	      // $main.css({"height": '100%'});

	      //scroll event array spと　tabletようだからいらないかも
	      // var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
	      var scroll_event = 'onwheel wheel onmousewheel mousewheel DOMMouseScroll touchmove';

	      if (!isMenuOpen) {
          // $(document.body).children().not($base).off(scroll_event,scrollPreventer);
          // $base.off(scroll_event, scrollPreventer);
          $('.l-utility__list__search,.l-utility__list__language_sm').show(300);
          $('.oc-auto_transform_notice').css('display','');
	        $opener.removeClass("is-open");
          $searchButton.css('display','block');
          // scrollPosition = $(window).scrollTop();
          $('body').css({
            'position': 'relative',
            'top': 0
          });
          tiltLandscape();
          window.scrollTo(0, scrollPosition);
	      }
        
        if(isMenuOpen){
          $('.l-utility__list__search,.l-utility__list__language_sm,.oc-auto_transform_notice').hide();
          $base.show(100,'swing');
          // $('body').scrollTop(0);
          $('.l-header').addClass('is-menu_open');
          // $('.l-header__nav__list__item.is-language').stop().delay(500).show(100);
          $('#l-utility').css({
            'borderBottom': 'none',
            'backgroundColor': 'transparent'
          });
        }else{
          $('.l-header').removeClass('is-menu_open');
          $('.l-header__nav__list__item.is-language').stop().hide(300);
          $base.delay(200).hide(100,'swing');
          $('#l-utility').css({
            'borderBottom': '',
            'backgroundColor': ''
          });
        }
	      // $base.css("display", isMenuOpen ? "" : "none");
        $base.toggleClass('menuScaleUp');
        // $menu.addClass('menuScaleUp');

	      if (isMenuOpen) {
          // $(document.body).children().not($base).on(scroll_event,scrollPreventer);
	        // $base.on(scroll_event, scrollPreventer);
          scrollPosition = $(window).scrollTop();
          (scrollPosition > 0) ? $('.c-spnav').addClass("is-fixed"):
          $('body').css({
            'position': 'fixed',
            'top' : - scrollPosition
          });
          tiltLandscape();
	        $opener.addClass("is-open");
          var $searchBtn = $opener.parent('.l-utility__list__hamburger').prev('.l-utility__list__search').find('.utility_box_trigger');
          $searchBtn.addClass("is-next_menu_open");


	        var listHeight = 0;
	        $parentItems.each(function() {
	          listHeight += $(this).height();
	        });
	        $scrollSpacer.height(Math.max(10, $(window).height() + listHeight));
          $searchButton.css('display','none');
	      }

	      // $(document.body).children().each(function(){
	      // 	var $target = $(this);
	      // 	if(isToggleTarget($target)){
	      // 		$target.css("display", isMenuOpen ? "none" : "");
	      // 	}
	      // })

	    };

	    /**
	     * sp menu trigger dom 
	     */
	    $parent.find('A[href]').each(function() {
	      $(this).on("click", function() {
	        window.setTimeout(function() {
            $(window).scrollTop(0);
	          toggleModalMenu();
	        }, 300);
	      });
	    });

	    /**
	     * sp menu trigger run 
	     */
	    $opener.on("mousedown", function(events) {
	      events.preventDefault();
				// $(window).scrollTop(0);
	      toggleModalMenu();
	    });
	    $opener.on("click", function(events) {
	      events.preventDefault();
        // control.headerTogglBox($('[data-search-trigger]'),'search');
        // control.headerTogglBox($('[data-language-trigger]'),'language');
        // $(window).scrollTop(0);
	    });

	    $(window).on("resize", function() {
	      if (isMenuOpen && $(document.documentElement).outerWidth() > 768) {
	        $base.css("display", "none");
	        toggleModalMenu(false);
	      }
	    });
		};    
    
		control.prepare = function(){
			$('A[href*="#refer:"]').each(function(){
				var href = $(this).attr("href");
				var index = href.indexOf("#");
				$(this).attr("href", href.slice(0, index) + "?n=" + (new Date().getTime()) + href.slice(index));
			});
		}
    /**
		 * SPでヘッダー設定タッチ時のオーバレイ機能 トグル
		 */


		var modalMode = '';
		var setTime = 300;
		control.headerModalClose = function(){
			$('.overlay_wrap').fadeOut(setTime);
			setTimeout(function(){
				$('.overlay_wrap').remove();
			},400);
      $('#l-utility').removeClass('over_front');
    }
    
    var headerModalOpen = function(){
      var modalOpen = ($('body').find('.overlay_wrap').length > 0) ? true : false;
			if(modalOpen == false){
  			$overlay = '<div class="overlay_wrap"></div>';
  			$('body').append($overlay);
        $('#l-utility').addClass('over_front');
  			$('.overlay_wrap').fadeIn(setTime).on('click',function(){
  				$('[data-util-extend-box]').each(function(){
  					$(this).removeClass('box_height',setTime);
            $('[data-language-trigger]').children('.c-icon').removeClass('rotate90');
  				});
  				control.headerModalClose();
  			});

	    }
		}
    var deviceSP = OH.browserInfo.isiOS || OH.browserInfo.isAndroid;
    var deviceSPMediaQuery = window.matchMedia('(max-width:768px)').matches;

    /**
		 * header の　言語とsearchボックス制御
		 */
		control.headerTogglBox = function($parent,boxMode){
      
      // sp
      var spHeaderTogglBox = function($parent){
        var $spMenu = $('[data-menu-toggle="mega_sp"]').eq(0);
        var $arrow = $('[data-language-trigger]').children('.c-icon');

        var closeMenu = function(){
          $spMenu.removeClass('is-open');
          $arrow.removeClass('rotate90');
          $utilBox.removeClass('over_front');
          $('.c-spnav').hide();
        }
        
  			$trigger = $parent;
  			$trigger.on('click',function(){
          var openMenuflg = $spMenu.hasClass('is-open');
          if(openMenuflg == true){
            closeMenu();
          }
          var $target = $(this).next('[data-util-extend-box]');
          var boxOpenFlg = ($target.height() > 0) ? true: false;
          if(!boxOpenFlg){
            $target.stop(false,true).addClass('box_height',setTime,function(){
              $('[data-util-extend-box]').not(this).removeClass('box_height',setTime);
            });
            setTimeout(function(){
                $('#sp_search_input').focus();
            },600);

            if(boxMode !== 'language'){
              $arrow.removeClass('rotate90');
            } else{
              $arrow.addClass('rotate90');
            }
            headerModalOpen();
          } else{
            $target.stop(false,true).removeClass('box_height',setTime);
            control.headerModalClose();
            $arrow.removeClass('rotate90');
          }
  			});
      };

      // pc
      var pcHeaderTogglBox = function($parent){
  			$trigger = $parent;
  			$trigger.on('click',function(){
          var $target = $(this).next('[data-util-extend-box]');
          var boxOpenFlg = ($target.hasClass('is-open_box')) ? true: false;
          if(!boxOpenFlg){
            $(this).addClass('open_search_box');
            $target.stop(false,true).removeClass('is-close_box').addClass('is-open_box',function(){
              $('[data-util-extend-box]').not(this).removeClass('is-open_box');
            });
            setTimeout(function(){
                $target.find('.search_input').focus();
            },600);
            
            // headerModalOpen();
          } else{
            $(this).removeClass('open_search_box');
            $target.stop(false,true).removeClass('is-open_box').addClass('is-close_box');
            // control.headerModalClose();
          }
  			});
      };


      if(!deviceSPMediaQuery){
        pcHeaderTogglBox($parent);
    	}else{
        spHeaderTogglBox($parent);
      }


    }
    
    

		return control;
	})();
})(jQuery);
